import { render, staticRenderFns } from "./DashboardCompras.vue?vue&type=template&id=5240f5b0&scoped=true"
import script from "./DashboardCompras.vue?vue&type=script&lang=js"
export * from "./DashboardCompras.vue?vue&type=script&lang=js"
import style0 from "./DashboardCompras.vue?vue&type=style&index=0&id=5240f5b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5240f5b0",
  null
  
)

export default component.exports